
<script>
import SearchForm from '@/components/views/searchForm/SearchForm.vue'
import LkEvents from './views/Events.vue'
import LkSale from './views/Sale.vue'
import LkTours from './views/Tours.vue'

export default {
  name: 'Lk',
  components: {
    SearchForm,
    LkEvents,
    LkSale,
    LkTours
  },
  metaInfo: {
    title: 'Личный кабинет'
  },
  created() {
    this.$store.dispatch('lk/getLk')
  }
}
</script>

<template>
  <div class="lk">
    <div class="lk__header">
      <img
        src="@/assets/images/pepe.png"
        alt=""
        class="lk__image"
      >
      <div class="lk__search-form">
        <search-form
          :is-links-mode="false"
        />
      </div>
    </div>
    <div class="lk__content">
      <lk-events />
      <lk-sale />
      <lk-tours />
    </div>
  </div>
</template>
